import { Modifier } from "@dnd-kit/core";

import { calculateGridSnapInCard } from "./utils/calculateGridSnapInCard/calculateGridSnapInCard";

export const snapHandleToGrid: Modifier = ({
  activatorEvent,
  active,
  containerNodeRect,
  over,
  transform,
}) => {
  if (
    !(activatorEvent instanceof PointerEvent) ||
    active?.data.current?.target !== "span-control" ||
    active?.rect.current.initial === null ||
    !over ||
    !containerNodeRect
  ) {
    return transform;
  }

  // SETUP
  const spanDirection = active?.data.current?.data.direction;

  const xScrollOffset =
    spanDirection === "right"
      ? containerNodeRect.right - active.rect.current.initial.right
      : containerNodeRect.left - active.rect.current.initial.left;

  const snapTo =
    spanDirection === "right"
      ? over?.rect.right - containerNodeRect.right
      : over?.rect.left - containerNodeRect.left;

  const relativeX = transform.x - xScrollOffset;

  const hasGoneBackACell =
    spanDirection === "right"
      ? relativeX < snapTo - over.rect.width
      : relativeX > snapTo + over.rect.width;

  const handleBuffer = active.rect.current.initial.width / 2;

  // If the handle is being dragged into its own cell container
  if (
    (spanDirection === "right" && relativeX <= 0) ||
    (spanDirection === "left" && relativeX >= handleBuffer)
  ) {
    const gridSize =
      containerNodeRect.width / active.data.current?.data.cellSpan;
    return {
      ...transform,
      x: calculateGridSnapInCard({
        spanDirection,
        containerWidth: containerNodeRect.width,
        gridSize,
        relativeX,
        xScrollOffset,
      }),
    };
  }

  // Allowing dndKit to handle this normally stops the handle locking in place
  if (hasGoneBackACell) {
    return transform;
  }

  // If the handle is being dragged outside its container
  return {
    ...transform,
    x:
      spanDirection === "right"
        ? snapTo + xScrollOffset > transform.x
          ? snapTo + xScrollOffset
          : transform.x
        : snapTo + xScrollOffset < transform.x
        ? snapTo + xScrollOffset
        : transform.x,
  };
};
